export default "__VITE_ASSET__Cmaz$0rY__"